// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'cc33bc7a-2a0f-4b31-aa76-e80317ec3307',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '8b6df223-fa1d-4725-b3ff-cdb79ef94489',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'cc33bc7a-2a0f-4b31-aa76-e80317ec3307',
      data: {
        rotationCycle: 30000
      }
    },
    {
      id: '37d4871c-1c8c-4799-b766-42f933b88c9c',
      type: 'Sprite',
      name: 'icon',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'large_coin',
      parent: 'cc33bc7a-2a0f-4b31-aa76-e80317ec3307',
      data: {
        maxSize: 80
      }
    },
    {
      id: '4675e460-3c0a-4f4a-a300-4339a1a9cee4',
      type: 'Text',
      name: 'amountText',
      className: '',
      x: 52,
      y: 0,
      anchor: {
        x: 1,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x79',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#8F2C2B',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'cc33bc7a-2a0f-4b31-aa76-e80317ec3307'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: 'e87f28d0-fec8-47f6-83d8-d10893e951af',
      name: 'PopOut',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: '2f9a4d94-371c-4c7c-89f1-621c10406d20',
          type: 'Setter',
          name: 'setScale_0',
          track: 3,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '5f73fa27-3060-4923-9edf-4e37b1be6c58',
          type: 'Tween',
          name: 'scaleTween_0',
          duration: 300,
          track: 2,
          target: {
            scale: {
              x: 2,
              y: 2
            }
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '648e4b57-be91-4545-b65d-c5babad73b12',
          type: 'Tween',
          name: 'positionTween_0',
          duration: 2000,
          track: 1,
          target: {
            y: -60
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'faf07db8-8abf-4bce-9e4f-614a20e44837',
          type: 'Tween',
          name: 'scaleTween_1_1',
          duration: 100,
          track: 2,
          target: {
            scale: {
              x: 1.8,
              y: 1.8
            }
          },
          startAt: 300,
          sourceName: 'root',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'a1d3659a-274e-4923-b6b1-bfb070e92979',
          type: 'Tween',
          name: 'setAlpha_0',
          duration: 300,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 1700,
          sourceName: 'root',
          easing: 'Linear',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class ShopItemRewardLayout {
  static raw = raw;
  root!: Container;
  rays!: Sprite & { data: typeof raw['list'][1]['data'] };
  icon!: Sprite & { data: typeof raw['list'][2]['data'] };
  amountText!: Text;
  rotate_SPL!: (Sprite & { data: typeof raw['list'][1]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class PopOut {
  Layout: {
    root: object;
  };

  BlockTypeByName: {
    setScale_0: object;
    scaleTween_0: object;
    positionTween_0: object;
    scaleTween_1_1: object;
    setAlpha_0: object;
  };

  flowData = raw.animations[0];
}
